import React from 'react';
import {useAppDispatch, useAppSelector} from '../../../../../../../../../app/hooks';
import {
    AppearanceTabSettingsContainer
} from '../../../../../../../../elements/appearanceTabSettingsContainer/AppearanceTabSettingsContainer';
import {AddButton} from '../../../../../../../../elements/addButton/AddButton';
import {ClickAction, UpdateVehicleDetailsButtonRequest} from '../../../../../../../../../api/generated';
import {
    selectVehicleDetailsButtons,
    updateVehicleDetailsButtons
} from '../../../../widgetAppearanceUpdateSlice';
import styles from './VehicleButtonCustomization.module.css';
import {VehicleButton} from "../VehicleButton/VehicleButton";

interface VehicleButtonCustomizationProps {
    getMessageWrapper: (fieldName: string) => string;
    updateValidationStatus: any;
}

const MAX_BUTTONS = 2;

export const VehicleButtonCustomization: React.FC<VehicleButtonCustomizationProps> = ({
                                                                                          getMessageWrapper,
                                                                                          updateValidationStatus
                                                                                      }) => {
    const dispatch = useAppDispatch();
    const vehicleButtons = useAppSelector(selectVehicleDetailsButtons) || [];

    const handleAddButton = () => {
        if (vehicleButtons.length < MAX_BUTTONS) {
            const newButton: UpdateVehicleDetailsButtonRequest = {
                buttonText: 'View Vehicle',
                clickAction: ClickAction.RedirectToDetailsPage,
                message: ''
            };
            dispatch(updateVehicleDetailsButtons([...vehicleButtons, newButton]));
        }
    };

    const handleUpdateButton = (index: number, updates: Partial<UpdateVehicleDetailsButtonRequest>) => {
        const newButtons = [...vehicleButtons];
        newButtons[index] = {...newButtons[index], ...updates};
        dispatch(updateVehicleDetailsButtons(newButtons));
    };

    const handleDeleteButton = (index: number) => {
        const newButtons = vehicleButtons.filter((_, i) => i !== index);
        dispatch(updateVehicleDetailsButtons(newButtons));
    };

    return <AppearanceTabSettingsContainer
        title="Vehicle Card Action Button Customisation"
        withSwitch={false}
    >
        <div className={styles.buttonsList}>
            {vehicleButtons.map((button, index) => (
                <VehicleButton
                    key={button.id ?? `new-${index}`}
                    button={button}
                    index={index}
                    onUpdate={handleUpdateButton}
                    onDelete={handleDeleteButton}
                    isTranslationMode={false}
                    getMessageWrapper={getMessageWrapper}
                    updateValidationStatus={updateValidationStatus}
                />
            ))}
        </div>
        <div className={styles.addButtonWrapper}>
            <AddButton
                onClick={handleAddButton}
                isEnabled={vehicleButtons.length < MAX_BUTTONS}
                text="Add Action Button"
            />
        </div>
    </AppearanceTabSettingsContainer>
}
